export class WeakMap2<K extends WeakKey, V> extends WeakMap<K, V> {
  getOrInsertComputed(key: K, factory: (key: K) => V) {
    if (this.has(key)) return this.get(key);
    const value = factory(key);
    this.set(key, value);
    return value;
  }
}
